import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ICON_PATHS } from './iconMap.js';
export function ThemeIcon({ id, size = '1em', title, style, className }) {
    if (!id)
        return null;
    const inner = ICON_PATHS[id];
    if (!inner)
        return null; // stale/unknown id → render nothing, never a broken box
    const dim = typeof size === 'number' ? `${size}px` : size;
    const decorative = !title;
    return (_jsxs("svg", { viewBox: "0 0 24 24", width: dim, height: dim, role: decorative ? undefined : 'img', "aria-hidden": decorative ? true : undefined, "aria-label": title, focusable: false, className: className, style: { display: 'inline-block', flexShrink: 0, verticalAlign: 'middle', ...style }, children: [title ? _jsx("title", { children: title }) : null, inner] }));
}
//# sourceMappingURL=ThemeIcon.js.map